// CSS Modules - component class name prefix: SingleImageText__

<template>
  <div :class="$style.container">
    <figure :class="$style.figure">
      <a :class="$style.primaryLink" :href="primaryLink">
        <div
          :class="$style.image"
          :style="{ backgroundImage: `url(${image})` }"
        >
          <img :src="image" />
          <figcaption>
            <h3 v-if="title">{{ title }}</h3>
            <div>{{ copy }}</div>
          </figcaption>
        </div>
      </a>
    </figure>
  </div>
</template>

<script>
export default {
  name: "SingleImageText",
  props: {
    image: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    copy: {
      type: String,
      required: false,
      default: ""
    },
    primaryLink: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module lang="scss">
@import "./SingleImageText.scss";
</style>
